// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';

import Navbarttt from './Components/Navbarttt';
import HeroBanner from './Components/HeroBanner';
import Footer1 from './Components/Footer1';
import ContactUs from './Components/ContactUs';
import SignupPage from './Components/SignupPage';
import Service from './Components/Service';
import TTTLoginForm from './Components/TTTLoginForm';
import AboutUsSection from './Components/AboutUsSection';
import OurProductPage from './Components/OurProductPage';
import TalentTrekPrivacyPolicy from './Components/Privacy & Policy';
import BlogPage9 from './Components/BlogPage9';
import CertificationCheck from "./Components/CertificationCheck";
import Admin from "./Components/Admin";
import Admin1 from "./Components/Admin1";
import ProtectedRoute from "./ProtectedRoute";
import usePageTracking from './hooks/usePageTracking';

const AppRoutes = () => {
  usePageTracking();

  return (
    <>
      <Navbarttt />
      <Routes>
        <Route path="/" element={<HeroBanner />} />
        <Route path="/about" element={<AboutUsSection />} />
        <Route path="/services" element={<Service />} />
        <Route path="/products" element={<OurProductPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={<TTTLoginForm />} />
        <Route path="/privacy" element={<TalentTrekPrivacyPolicy />} />
        <Route path="/blog" element={<BlogPage9 />} />
        <Route path="/view-certification" element={<CertificationCheck />} />

        {/* 🔵 OLD ADMIN */}
        <Route
          path="/admin-1"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />

        {/* 🟢 NEW ADMIN */}
        <Route
          path="/admin-2"
          element={
            <ProtectedRoute>
              <Admin1 />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer1 />
    </>
  );
};

function App() {
  useEffect(() => {
    ReactGA.initialize('G-Z5P6YYXVL4');
  }, []);

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;